import React, { useEffect } from "react";

const TopNav = () => {
  useEffect(() => {
    const handleScroll = () => {
      const logo = document.querySelector(
        ".navbar-logo.fa-kit-duotone.fa-scu-primary-logo",
      );
      if (window.scrollY > 50) {
        logo.classList.add("scrolled");
      } else {
        logo.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-white d-lg-block py-0 fixed-top nav-fixed initial nav-users"
      id="navbarUsers"
      role="navigation"
    >
      <div className="container">
        <div className="dropdown nav-brand-mini" id="navBrandMini" style={{}}>
          <a href="/">
            <i className="navbar-logo fa-kit-duotone fa-scu-primary-logo" />
            <span className="sr-only">Santa Clara University Homepage</span>
          </a>
        </div>

        <ul className="nav-link-list navbar-nav ml-auto">
          <li className="nav-item mr-1">
            <a className="nav-link collapsed px-3" href="/services/">
              Offices &amp; Services
            </a>
          </li>
          <li className="nav-item ml-1">
            <a className="nav-link collapsed px-3" href="/schools-and-centers/">
              Schools &amp; Centers
            </a>
          </li>
          <li className="nav-item dropdown dropdown-search ml-1">
            <a
              className="nav-link"
              href="/search/"
              id="dropdownSearch"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="sr-only">Search</span>{" "}
              <i aria-hidden="true" className="fas fa-search text-primary" />
            </a>
            <div className="dropdown-menu" aria-labelledby="dropdownSearch">
              <form
                className="p-3"
                method="get"
                action="https://www.scu.edu/search/"
              >
                <div className="input-group">
                  <input
                    className="form-control"
                    id="q"
                    name="q"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                  />
                  <div className="input-group-append">
                    <button
                      className="input-group-text btn btn-outline-primary"
                      type="submit"
                    >
                      <span className="sr-only">Search</span>
                      <i aria-hidden="true" className="fas fa-search" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default TopNav;

